<template>
  <CRow>
    <CCol col="12 ">
      <CCard>
        <CCardBody>
          <h2>Pacientes</h2>
          <CDataTable
            :items="errors"
            :fields="fields"
            column-filter
            hover
            sorter
            small
            :items-per-page="5"
            pagination
          >
            <template #acao="{ item }">
              <td >
                <CButton color="primary" variant="outline" square size="sm" >
                  <router-link
                    class="router-link-ver"
                    :to="{
                      path: `/pacientes`,
                      name: 'Pacientes',
                      query: { id: item.identity, type: 'b', from: 'error', page: 'integration' },
                    }"
                    >VER</router-link
                  >
                </CButton>
              </td>
            </template>
          </CDataTable>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>
<script>
export default {
  data() {
    return {
      errors: [],
      fields: [
       
        {
          key: "error",
          label: "Erro",
          _style: "min-width:40px;",
          filter: true,
        },
        {
          key: "namepatient",
          label: "Paciente",
          _style: "min-width:40px;",
          filter: true,
        },
        {
          key: "acao",
          label: "Paciente",
          _style: "min-width:40px;",
          filter: true,
        },
      ],
    };
  },
  methods: {
    getDateIntgrationPatients() {
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}integration/patients`)
        .then((res) => res.json())
        .then((res) => {
          this.errors = res;
          
        })
        .catch((error) => {
          
        });
    },
    perfil(item, index) {
      
      
    },
  },

  mounted() {
    this.getDateIntgrationPatients();
  },
};
</script>
<style scoped></style>
